import StarterKit from "./StarterKit";

import Banner from "./components/Banner";
import HeaderFull from "./components/HeaderFull";
import HeaderBurger from "./components/HeaderBurger";
import Breadcrumbs from "./components/Breadcrumbs";

import Lines from "./components/Lines";
import BlockCollapse from "./blocks/BlockCollapse";
import BlockGallery from "./blocks/BlockGallery";
import BlockGallerySlider from "./blocks/BlockGallerySlider";
import BlockMap from "./blocks/BlockMap";
import BlockMovie from "./blocks/BlockMovie";
import BlockQuotes from "./blocks/BlockQuotes";
import BlockTeam from "./blocks/BlockTeam";
import BlockSlider from "./blocks/BlockSlider";
import BlockSliderScrollable from "./blocks/BlockSliderScrollable";
import BlockScrollingText from "./blocks/BlockScrollingText";

import BlockProjectsHighlight from "./blocks/BlockProjectsHighlight";
import PagesProject from "./pages/PagesProject";
import PagesNews from "./pages/PagesNews";
import Search from "./components/Search";

document.addEventListener("DOMContentLoaded", function () {
	// Starterkit
	StarterKit.init();

	// Components
	HeaderFull.init();
	HeaderBurger.init();
	Banner.init();
	Breadcrumbs.init();
	Search.init();

	// Blocks
	BlockCollapse.init();
	BlockGallery.init();
	BlockGallerySlider.init();
	BlockMap.init();
	BlockMovie.init();
	BlockQuotes.init();
	BlockTeam.init();
	BlockSlider.init();
	BlockScrollingText.init();
	BlockSliderScrollable.init();

	// Custom
	BlockProjectsHighlight.init();
	PagesNews.init();
	PagesProject.init();

	// Animation des lines horizontales et verticales
	Lines.init();
});
